export default (id: string, result_id: string) => {
    typeof window !== 'undefined' &&
        typeof (window as any).nostojs === 'function' &&
          (window as any).nostojs(api => api.recordAttribution({
                    type: 'vp',
                    target: id.split('/').slice(-1)[0],
                    ref: result_id,
                    refType: 'rec'
                }).done()
            )
};
